import React, { Component } from "react";
import { Image } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { RouteComponentProps, withRouter } from "react-router-dom";
import language from "../../../assets/images/language.svg";
import { logFirebaseEvent } from "../../../shared/utility";
import * as homeActions from "../../../store/actions/";
import classes from "../Logout/Logout.module.css";

interface IStateFromProps {
  config_values: {
    customValue: string | null;
    defaultValue: string;
    element: string;
    elementType: string;
    id: string;
    targetPageTitle: string;
  }[];
  t: any;
  i18n: any;
}
interface IDispatchFromProps {
  onFetchAppConfig: (language) => void;
  onFetchMyPlansDocuments: (
    userId: string,
    pageNumber: number,
    pageSize: number
  ) => void;
}

type Props = IStateFromProps & RouteComponentProps & IDispatchFromProps;
class LanguageSwitch extends Component<Props> {
  state = {
    activeClass: "english",
    pageNumber: 0,
    pageSize: 0,
    currentCount: 0,
  };
  handleConfigDetails = async (language: string) => {
    console.log("handleConfigDetails-----------");
    await this.props.onFetchAppConfig(language);
  };

  render() {
    const { t, i18n } = this.props;

    return (
      <div className={classes.langOver}>
        <a className={classes.langDisplay}>
          <Image src={language} alt="language" />
          <span>{t("header.switchLanguage")}</span>
        </a>
        <div className={classes.langDropdown}>
          <span className={classes.langCaret}></span>
          <ul>
            <li
              className={
                this.state.activeClass === "english" ? classes.active : ""
              }
              onClick={() => {
                logFirebaseEvent("EnglishLanguageSelection");
                i18n.changeLanguage("en");
                this.setState({ activeClass: "english" });
                this.handleConfigDetails("en");
                this.props.onFetchMyPlansDocuments(
                  localStorage.getItem("userId")!,
                  this.state.pageNumber,
                  this.state.pageSize
                );
              }}
            >
              {t("language.english")}
            </li>
            <li
              className={
                this.state.activeClass === "spanish" ? classes.active : ""
              }
              onClick={() => {
                logFirebaseEvent("SpanishLanguageSelection");
                i18n.changeLanguage("sp");
                this.setState({ activeClass: "spanish" });
                this.handleConfigDetails("es");
                this.props.onFetchMyPlansDocuments(
                  localStorage.getItem("userId")!,
                  this.state.pageNumber,
                  this.state.pageSize
                );
              }}
            >
              {t("language.spanish")}
            </li>
          </ul>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state: any) => ({
  config_values: state.appConfig.config_values,
});
const mapDispatchToProps = (dispatch): IDispatchFromProps => ({
  onFetchAppConfig: (language) =>
    dispatch(
      homeActions.fetchAppConfig(localStorage.getItem("userId")!, language)
    ),
  onFetchMyPlansDocuments: (userId, pageSize, pageNumber) =>
    dispatch(homeActions.fetchMyPlansDocuments(userId, pageSize, pageNumber)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(withTranslation()(LanguageSwitch)));
